export default __webpack_public_path__ + "static/media/toy6.e71b703f.jfif";